import script from "./PersonalInfoStep1Content.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfoStep1Content.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfoStep1Content.vue?vue&type=style&index=0&id=2ac68008&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac68008"]])

export default __exports__